import { useEffect } from "react";
import { channelService } from "./ChannelService";
import { BrowserRouter, Route, Routes } from "react-router";
import { Landing } from "./screens/Landing";
import { routes } from "./routes";
import { EmailLogin } from "./screens/EmailLogin";
import { PhoneNumberLogin } from "./screens/PhoneNumberLogin";
import { Login } from "./screens/Login";
import { firestore } from "./firebase";
import { doc, getDoc } from "firebase/firestore";
import { Result } from "./screens/Result";
import { ResultType } from "./types";
import { ResetPassword } from "./screens/ResetPassword";
import { Code } from "./screens/Code";

const App = () => {
  useEffect(() => {
    channelService.loadScript();
    channelService.boot({
      pluginKey: "32f9de36-1e7c-4c66-ac3a-cff27b99e38c", // fill your plugin key
    });
  }, []);

  useEffect(() => {
    const { pathname, search } = window.location;
    if (pathname.includes("code")) return;
    const organization = search.split("organization=")[1]?.split("&")?.[0];
    const invitation = search.split("invitation=")[1]?.split("&")?.[0];
    if (!organization || !invitation) {
      if (pathname.includes("result")) return;
      window.location.href = `/result?result=${ResultType.bad_invitation}`;
    } else {
      getDoc(
        doc(
          firestore,
          `organizations/${organization}/studentInvitations/${invitation}`
        )
      )
        .then(async (snapshot) => {
          if (!snapshot.exists) {
            throw new Error("잘못된 초대 링크입니다.");
          } else {
            const data = snapshot.data();
            if (!data) {
              throw new Error("잘못된 초대 링크입니다.");
            }
            if (data.status === "canceled") {
              throw new Error("만료된 초대 링크입니다.");
            }
            if (data.status === "accepted") {
              throw new Error("이미 수락된 초대 링크입니다.");
            }
          }
        })
        .catch((e) => {
          alert(e.message);
        });
    }
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route index element={<Landing />} />
        <Route path={routes.code} element={<Code />} />
        <Route path={routes.ios} element={<Login />} />
        <Route path={routes.android} element={<Login />} />
        <Route path={routes.emailLogin} element={<EmailLogin />} />
        <Route path={routes.resetPassword} element={<ResetPassword />} />
        <Route path={routes.phoneNumberLogin} element={<PhoneNumberLogin />} />
        <Route path={routes.result} element={<Result />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
